import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Ship, Lock, Mail } from "lucide-react";

const AdminLogin = () => {

  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);


  const handleLogin = async (e) => {

    e.preventDefault();

    setError("");
    setLoading(true);

    try {

      const response = await fetch(
        "/api/admin/login",
        {
          method: "POST",

          headers: {
            "Content-Type": "application/json"
          },

          body: JSON.stringify({
            email,
            password
          })
        }
      );

      const data = await response.json();

      if (!response.ok) {
        throw new Error(
          data.message || "Login failed"
        );
      }

      localStorage.setItem(
        "indiaboatsAdminToken",
        data.token
      );

      localStorage.setItem(
        "indiaboatsAdmin",
        JSON.stringify(data.admin)
      );

      navigate("/admin");

    } catch (error) {

      setError(error.message);

    } finally {

      setLoading(false);

    }
  };


  return (
    <div className="cms-login-page">

      <div className="cms-login-card">

        <div className="cms-login-logo">

          <div className="cms-login-icon">
            <Ship size={26} />
          </div>

          <h1>IndiaBoats</h1>

          <span>CMS</span>

        </div>


        <div className="cms-login-heading">

          <h2>Welcome Back</h2>

          <p>
            Sign in to manage your website.
          </p>

        </div>


        {error && (
          <div className="cms-login-error">
            {error}
          </div>
        )}


        <form onSubmit={handleLogin}>

          <div className="cms-login-field">

            <label>
              Email Address
            </label>

            <div className="cms-login-input">

              <Mail size={17} />

              <input
                type="email"
                value={email}
                onChange={(e) =>
                  setEmail(e.target.value)
                }
                placeholder="Enter your email"
                required
              />

            </div>

          </div>


          <div className="cms-login-field">

            <label>
              Password
            </label>

            <div className="cms-login-input">

              <Lock size={17} />

              <input
                type="password"
                value={password}
                onChange={(e) =>
                  setPassword(e.target.value)
                }
                placeholder="Enter your password"
                required
              />

            </div>

          </div>


          <button
            type="submit"
            className="cms-login-btn"
            disabled={loading}
          >

            {loading
              ? "Signing in..."
              : "Sign In"
            }

          </button>

        </form>

      </div>

    </div>
  );
};

export default AdminLogin;